module.exports = __webpack_public_path__ + "img/drug_example_pic.a63516d7.png";